import { SeatType } from '@vista-digital/ocapi-types/v1';
import { Validator } from '@vista-digital/validator';
export const seatTypeValidator = Validator.oneOf(Object.values(SeatType));
